import type { ErrorMessageType } from "@/lib/server/errors/error-message";

type ApiErrorBody = { error?: string; type?: string; statusCode?: number };

function getApiErrorBody(error: unknown): ApiErrorBody | null {
  const response = (error as { response?: { data?: ApiErrorBody } } | null)
    ?.response;
  return response?.data ?? null;
}

export function getApiErrorType(error: unknown): ErrorMessageType | null {
  const body = getApiErrorBody(error);
  return (body?.type as ErrorMessageType) ?? null;
}

export function getApiErrorMessage(error: unknown): string | null {
  return getApiErrorBody(error)?.error ?? null;
}

export function isInterviewIntentConfirmationRequired(error: unknown): boolean {
  return getApiErrorType(error) === "INTERVIEW_INTENT_CONFIRMATION_REQUIRED";
}

export function getOffPlatformMessagePolicyError(
  error: unknown
): "blocked" | null {
  const type = getApiErrorType(error);
  if (type === "OFF_PLATFORM_CONTACT_BLOCKED") {
    return "blocked";
  }
  return null;
}
